import React, { useState } from "react";
import { X } from "lucide-react"; // Per il tasto chiudi

export default function JurySection() {
  const [selectedYear, setSelectedYear] = useState("2026");
  const [selectedJudge, setSelectedJudge] = useState(null); // Stato per il giudice ingrandito

  const hopPlaceholder = "/assets/Luppolo.webp";

  const judgesData = {
    "2026": [
      { id: 24, name: "Giacomo Manni", role: "Titolare e Birraio di Manth Birrificio Botanico ", bio: "Ex birraio presso Ritual Lab con Master alla Heriot Watt, esperienze internazionali tra USA, Norvegia e Olanda.", photo_url: "/assets/Giacomo Manni.jpg" },
      { id: 25, name: "Alessio Cartoni", role: "Birraio presso Ritual Lab", bio: "Grande conoscitore delle tecniche produttive e attento valutatore della qualità organolettica.", photo_url: "/assets/Alessio Cartoni.jpeg" },
      { id: 26, name: "Francesco Antonelli", role: "Grand Master BJCP judge - Certified Cicerone", bio: "Homebrewer dal 2012, autore, blogger, podcaster, un punto di riferimento per il panorama birraio a 360 gradi.", photo_url: "/assets/Francesco Antonelli.jpg" },
      { id: 27, name: "Cristiano Parise", role: "Giudice BJCP", bio: "Precisione stilistica e attenzione ai dettagli tecnici sono i pilastri della sua valutazione.", photo_url: "/assets/Cristiano Parise.jpg" },
      { id: 28, name: "Giordano Sagramola", role: "Birraio Fustock Farm", bio: "Formazione in Canada (Kwantlen Polytechnic), fondatore di Mashroom e birraio presso Fustock Farm.", photo_url: "/assets/Giordano Sagramola.jpg" },
      { id: 29, name: "Matteo Biasi", role: "Degustatore", bio: "Esperto degustatore, porta rigore e attenzione analitica nella valutazione dei campioni in gara.", photo_url: "/assets/Matteo Biasi.jpg" }
    ],
    "2023": [
      { id: 1, name: "Maurizio Romiti", role: "UBT & BJCP Candidate", bio: "Famoso homebrewers dal 2013, appassionato di birra a 360°. Qualifica UBT con specializzazione in degustazione e analisi sensoriale.", photo_url: "/assets/Maurizio-Romiti.jpg" },
      { id: 2, name: "Daniele Iuppariello", role: "Giudice BJCP & Podcaster", bio: "Programmatore informatico e homebrewer navigato. Degustatore certificato UBT e giudice BJCP, podcaster e blogger.", photo_url: "/assets/Daniele Iuppariello.png" },
      { id: 3, name: "Francesco Antonelli", role: "Grand Master BJCP judge - Certified Cicerone", bio: "Homebrewer dal 2012, autore, blogger, podcaster, un punto di riferimento per il panorama birraio a 360 gradi.", photo_url: "/assets/Francesco Antonelli.jpg" },
      { id: 4, name: "Giacomo Manni", role: "Titolare e Birraio di Manth Birrificio Botanico", bio: "Ex birraio presso Ritual Lab con Master alla Heriot Watt, esperienze internazionali tra USA, Norvegia e Olanda.", photo_url: "/assets/Giacomo Manni.jpg" },
      { id: 5, name: "Lorenzo Zucconi", role: "Giudice BJCP & Tapster", bio: "Homebrewer dal 2019, Brewery Tapster di Pilsner Urquell. Ha rappresentato l’Italia in 'Beer Masters'.", photo_url: "/assets/Lorenzo Zucconi.png" },
      { id: 6, name: "Francesco Cordovani", role: "Direttivo Mo.Bi. & BJCP", bio: "Giudice BJCP dal 2018, collaboratore di Birra Nostra Magazine e organizzatore del Campionato Homebrewer.", photo_url: "/assets/Francesco Cordovani.png" },
      { id: 7, name: "Giordano Sagramola", role: "Birraio Fustock Farm", bio: "Formazione in Canada (Kwantlen Polytechnic), fondatore di Mashroom e birraio presso Fustock Farm.", photo_url: "/assets/Giordano Sagramola.jpg" },
      { id: 8, name: "Jacopo Borghetti", role: "Mastro Birraio", bio: "Formazione a Barcellona, titolo BJCP e mastro birraio. Esperto di distribuzione nel territorio umbro.", photo_url: "/assets/Jacopo Borghetti.png" }
    ],
    "2024": [
      { id: 9, name: "Daniele Iuppariello", role: "Giudice BJCP", bio: "Conferma la sua presenza tecnica per valutare l'aderenza agli stili con rigore e competenza.", photo_url: "/assets/Daniele Iuppariello.png" },
      { id: 10, name: "Simone Cantoni", role: "Degustatore & Giornalista", bio: "Esperto di fama nazionale nel panorama brassicolo, noto per la sua capacità di analisi e narrazione.", photo_url: "/assets/Simone Cantoni.jpg" },
      { id: 11, name: "Francesco Cordovani", role: "Mo.Bi.", bio: "Esponente del Movimento Birrario Italiano, porta la sua esperienza nella crescita del movimento HB.", photo_url: "/assets/Francesco Cordovani.png" },
      { id: 12, name: "Giacomo Manni", role: "Titolare e Birraio di Manth Birrificio Botanico", bio: "Ex birraio presso Ritual Lab con Master alla Heriot Watt, esperienze internazionali tra USA, Norvegia e Olanda.", photo_url: "/assets/Giacomo Manni.jpg" },
      { id: 13, name: "Giordano Sagramola", role: "Fustock Farm", bio: "Dalla produzione alla spillatura, una visione completa per valutare ogni sfumatura della birra.", photo_url: "/assets/Giordano Sagramola.jpg" },
      { id: 14, name: "Alessio Cartoni", role: "Birraio presso Ritual Lab", bio: "Grande conoscitore delle tecniche produttive e attento valutatore della qualità organolettica.", photo_url: "" },
      { id: 15, name: "Cristiano Parise", role: "Giudice BJCP", bio: "Precisione stilistica e attenzione ai dettagli tecnici sono i pilastri della sua valutazione.", photo_url: "/assets/Cristiano Parise.jpg" },
      { id: 16, name: "Alberto Vallini", role: "Analista Sensoriale", bio: "Esperto nell'individuare profili aromatici complessi e potenziali difetti nei campioni presentati.", photo_url: "/assets/Alberto Vallini.png" }
    ],
    "2025": [
      { id: 17, name: "Francesco Antonelli", role: "Grand Master BJCP judge Certified Cicerone", bio: "Homebrewer dal 2012, autore, blogger, podcaster, un punto di riferimento per il panorama birraio a 360 gradi..", photo_url: "/assets/Francesco Antonelli.jpg" },
      { id: 18, name: "Daniele Iuppariello", role: "Giudice BJCP", bio: "Colonna portante della giuria, garantisce continuità e standard qualitativi elevati.", photo_url: "/assets/Daniele Iuppariello.png" },
      { id: 19, name: "Daniele Cogliati", role: "Giudice BJCP", bio: "Analisi tecnica puntuale e grande conoscenza degli stili classici internazionali.", photo_url: "" },
      { id: 20, name: "Maurizio Romiti", role: "UBT", bio: "Specialista dell'analisi sensoriale, valuta con occhio critico l'equilibrio e la bevibilità.", photo_url: "/assets/Maurizio-Romiti.jpg" },
      { id: 21, name: "Cristiano Parise", role: "Giudice BJCP", bio: "Riconfermato per la sua capacità di fornire feedback costruttivi e tecnici agli homebrewers.", photo_url: "/assets/Cristiano Parise.jpg" },
      { id: 22, name: "Vincenzo Mulè", role: "Beer Specialist", bio: "Esperto conoscitore del panorama artigianale italiano, attento all'innovazione e alla tecnica.", photo_url: "/assets/Vincenzo Mule.jpg" },
      { id: 23, name: "Matteo Biasi", role: "Degustatore", bio: "Nuovo ingresso in giuria, porta freschezza e rigore nella valutazione dei campioni 2025.", photo_url: "/assets/Matteo Biasi.jpg" }
    ]
  };

  const years = ["2026", "2025", "2024", "2023"];

  return (
    <section id="giuria" className="bb-section pt-20 pb-20 bg-black">      
      <div className="bb-container mx-auto px-4">
        
        {/* HEADER E SELETTORE ANNI */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="text-left">
            <span className="bb-eyebrow" style={{ color: "var(--bb-primary)" }}>Albo d'Oro Giuria</span>
            <h2 className="bb-display text-5xl md:text-7xl lg:text-8xl mt-5 leading-[0.95] uppercase tracking-tighter">
              LA <span style={{ color: "var(--bb-primary)" }}>GIURIA</span>
            </h2>
            <p className="text-zinc-500 mt-6 max-w-xl text-sm md:text-base leading-relaxed uppercase tracking-widest opacity-80 font-medium italic">
              Esperti, birrai e giudici certificati che hanno fatto la storia del Beer Battle.
            </p>
          </div>
          
          <div className="flex flex-wrap gap-2">
            {years.map((year) => (
              <button
                key={year}
                onClick={() => setSelectedYear(year)}
                className={`px-8 py-3 text-xs font-black tracking-widest transition-all border ${
                  selectedYear === year 
                  ? "bg-[#c49a45] border-[#c49a45] text-black" 
                  : "border-zinc-800 text-zinc-500 hover:border-[#c49a45]/50"
                }`}
              >
                {year}
              </button>
            ))}
          </div>
        </div>

        {/* GRIGLIA PULITA */}
        <div className="animate-fadeIn">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-10">
            {judgesData[selectedYear]?.map((j) => (
              <article 
                key={j.id} 
                className="group cursor-pointer text-left" 
                onClick={() => setSelectedJudge(j)}
              >
                <div className="aspect-square overflow-hidden mb-5 bg-zinc-950 relative border border-zinc-900">
                  <img
                    src={j.photo_url || hopPlaceholder}
                    alt={j.name}
                    className="w-full h-full object-cover grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700"
                  />
                </div>
                <h3 className="text-sm font-bold text-white uppercase tracking-tight leading-tight">{j.name}</h3>
                <p className="text-[10px] uppercase tracking-widest text-[#c49a45] font-black mt-1">{j.role}</p>
                <p className="text-xs text-zinc-500 mt-4 leading-relaxed line-clamp-2 italic opacity-80 group-hover:opacity-100">
                  {j.bio}
                </p>
              </article>
            ))}
          </div>
        </div>

        {/* MODALE: IL GIUDICE INGRANDITO */}
        {selectedJudge && (
          <div 
            className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-black/90 backdrop-blur-sm animate-fadeIn"
            onClick={() => setSelectedJudge(null)}
          >
            <div 
              className="relative bg-zinc-950 border border-[#c49a45] p-8 md:p-10 max-w-md w-full shadow-[0_0_50px_rgba(196,154,69,0.2)]"
              onClick={(e) => e.stopPropagation()}
            >
              <button 
                onClick={() => setSelectedJudge(null)}
                className="absolute -top-12 right-0 text-[#c49a45] hover:text-white transition-colors flex items-center gap-2 uppercase text-[10px] font-bold tracking-widest"
              >
                Chiudi <X size={20} />
              </button>

              <div className="aspect-[4/5] overflow-hidden mb-8 bg-zinc-900 border border-zinc-800">
                <img
                  src={selectedJudge.photo_url || hopPlaceholder}
                  alt={selectedJudge.name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="text-left">
                <h3 className="text-2xl font-bold text-white uppercase tracking-tight mb-2 leading-tight">
                  {selectedJudge.name}
                </h3>
                <p className="text-xs uppercase tracking-[0.3em] text-[#c49a45] font-black mb-6">
                  {selectedJudge.role}
                </p>
                <p className="text-sm text-zinc-400 leading-relaxed italic">
                  {selectedJudge.bio}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Sponsor 2023 */}
        {selectedYear === "2023" && !selectedJudge && (
          <div className="mt-20 py-10 border-t border-zinc-900 flex flex-col items-center">
            <span className="text-zinc-600 uppercase tracking-[0.3em] text-[9px] mb-4 font-bold">Powered By</span>
            <div className="bg-white/5 px-8 py-4 border border-zinc-800/50 text-zinc-300 font-bold text-xl uppercase">
              Mr. Malt <span className="text-[#c49a45] text-sm align-top">Italy</span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}